import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert, ComPhoto, NoResult } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능:거래승인요청 리스트
 * 세부설명:
*/

export class RequestList extends Component {
    static displayName = RequestList.name;
    constructor(props) {
        super(props);
        this.state = {
            TotalCount: 0,
            RetailList: [],

        };
        this.Page_Number = 1;
        this.Page_Size = Big3Common.WebConfig.Page_Size;
        this.handleConfirm_Click = this.handleConfirm_Click.bind(this);
        this.handelDtl_Click = this.handelDtl_Click.bind(this);
        this.handleAdd_Click = this.handleAdd_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        this.CallRetailGrupData();
    }
    
    async CallRetailGrupData(isAppend) {
        try {

            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/Retail/RetailMgr/GetRetailGrupListWA',
                {
                    "page_number": this.Page_Number,
                    "page_size": this.Page_Size
                }
            );
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const RetailList = JSON.parse(Data.dataTable);
                const TotalCount = (this.Page_Size * this.Page_Number);
                if (isAppend) {
                    const RetailListPush = this.state.RetailList;
                    RetailList.map(list => RetailListPush.push(list));
                    this.setState({ RetailList: RetailListPush, TotalCount: TotalCount });
                }
                else {

                    this.setState({ RetailList: RetailList, TotalCount: TotalCount });
                }
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallRetailGrupData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    handleAdd_Click(event) {
        this.Page_Number++;
        this.CallRetailGrupData(true);
        event.preventDefault();
    }
    async handleConfirm_Click(union_uid) {
        try {
            let Data = await Big3Common.Get(`api/Retail/RetailMgr/SetRetailGrupConfirm/${union_uid}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                Big3Common.ModalAlert(bootstrap, 'AlertBox');
                this.Page_Number = 1;
                this.CallRetailGrupData();
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("handleConfirm_Click: ", e)
        }
        return false;
    }
    handelDtl_Click(event,union_uid) {
        let StateCopy = Big3Common.WebStorage.StateStorage(this.state, ["RetailList"]);
        StateCopy.Union_Id = union_uid;
        this.props.RenderComponent('RtiDtl', StateCopy);
        event.preventDefault();
    }
    render() {
        let RetailList = this.state.RetailList;
        return (
            <div>
                <div className="tap_box tap_box_v2">
                    <div className="n_tap">
                        <Link to="/Retail/MyRetail/Index">
                            <div className="alert_tap">내 거래처</div>
                        </Link>
                    </div>
                    <div className="n_tap"><div className="alert_tap tap_on">승인요청</div></div>
                </div>
                <div className="container_box d_padding m_f_margin">
                    {RetailList.map(list =>
                        <div className="alert_content" key={list.union_uid}>
                            <div className="alert_img pointer" onClick={(e) => this.handelDtl_Click(e, list.union_uid)}>
                                <ComPhoto className="alert_img_in" Photo={list.retail_photo} />
                            </div>
                            <div className="alert_txt">
                                <div className="alert_title order_title pointer" onClick={(e) => this.handelDtl_Click(e, list.union_uid)}>[{list.retail_area_nm}] {list.retail_org_name}</div>
                                <div className="product_name order_name">Clo:D 거래액: {Big3Common.Util.Money(list.mon_trunover)}원</div>
                                <div className="product_name order_name">Clo:D 주문수: {Big3Common.Util.Money(list.mon_ordnumber)}건</div>
                                <div className="order_btn or_btn3" onClick={() => this.handleConfirm_Click(list.union_uid)}>거래승인</div>
                            </div>
                        </div>                   
                    )}
                    {this.state.TotalCount === this.state.RetailList.length && this.state.TotalCount > 0 ? <button type="button" className="btn_v btn_inactive" onClick={this.handleAdd_Click}>더보기</button> : ""}
                </div>
                <Alert
                    id="AlertBox"
                    title="승인되었습니다."
                />
                <NoResult
                    Visible={this.state.RetailList.length === 0 ? true : false}
                    Top={"50%"}
                />
            </div>
        );
    }
}
